import { api } from '../config/api';

export const authService = {
  login: async (email, password) => {
    return api.post('/api/auth/login', { email, password });
  },
  
  getProfile: async () => {
    return api.get('/api/auth/me');
  },
  
  changePassword: async (currentPassword, newPassword) => {
    return api.post('/api/auth/change-password', { currentPassword, newPassword });
  },
  
  logout: async () => {
    return api.post('/api/auth/logout', {});
  }
};
